<style src="./AgedCard.scss" lang="scss" scoped></style>
<template>
  <div class="aged-card">
    <span class="title">Exceção</span>

    <ul class="list">
      <li v-for="(photo, photoIdx) in info" :key="photoIdx" class="photos">
        <i @click="openImage(photo)" class="fa fa-camera icon"> </i>
      </li>
    </ul>
  </div>
</template>

<script>
import { URI } from '../../../config/config';

export default {
  name: 'Aged',
  props: {
    info: {
      default: null,
    },
  },
  methods: {
    openImage(photo) {
      let photoPath = photo.replace(
        '/var/app/server-user-manager/notify-photos/',
        '',
      );
      photoPath = photoPath.replace(
        '/var/app/server-manager/notify-photos/',
        '',
      );
      window.open(`${URI}${photoPath}`);
    },
  },
};
</script>